var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.notifications,"items-per-page":10,"sort-by":['id'],"sort-desc":""},scopedSlots:_vm._u([{key:"item.dispatch_time",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.formatDate(item.dispatch_time))+"\n  ")]}},{key:"item.reading_date",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.formatDate(item.reading_date))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }